import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Divider,
  HStack,
  Link,
  Stack,
  Text,
  VStack,
  Box,
  useToast,
  SimpleGrid,
  Tooltip,
  Icon,
  Flex,
  Image,
} from "@chakra-ui/react";
import dayjs from "dayjs";
import jalali from "jalali-dayjs";
import { Trash2, ScanEye, ShieldCheck } from "lucide-react";

import { useEffect, useState } from "react";

import { MyAlert } from "../MyAlert";
import { MyModal } from "../MyModal";
import { SearchBar } from "../SerachBar";
import { Pagination } from "../Pagination";
import {
  RemoveInvoice,
  SetInvoiceIsAccepted,
  ShowInvoiceApprovedFile,
  ShowReadyToAcceptInvoiceList,
} from "../../api/services/invoiceService";
import { MyLoading } from "../MyLoading";
import { MyInvoiceStepper } from "../MyInvoiceStepper";
export const InvoiceRequests = ({ isDesktop }) => {
  const [currentInvoicePage, setCurrentInvoicePage] = useState(1);
  const [invoiceSearch, setInvoiceSearch] = useState("");
  const [totalInvoicePages, setTotalInvoicePages] = useState(0);
  const itemsPerPage = 12;
  const [approvedFile, setApprovedFile] = useState(null);
  const [invoices, setInvoices] = useState([]);
  const [invoiceSelectedID, setInvoiceSelectedID] = useState(0);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const toast = useToast();

  const [dialogGears, setDialogGears] = useState({
    title: "",
    text: "",
    callBack: null,
  });

  const loadInvoiceData = async (resetPage = false) => {
    setLoading(true);
    const res = await ShowReadyToAcceptInvoiceList(
      resetPage ? 1 : currentInvoicePage,
      itemsPerPage,
      resetPage ? "" : invoiceSearch
    );
    if (!res.success) {
      toast({
        title: "خطا در دریافت داده‌ها",
        description: res?.error,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      setLoading(false);
      return;
    }
    setTotalInvoicePages(Math.ceil(res?.data?.total / itemsPerPage));
    // const newInvoices = res.data.items.filter(
    //   (i) => i.isAccepted == false && i.isSent == true && i.approvedFile
    // );
    setInvoices(res?.data?.items);
    setLoading(false);
  };

  const handleResetInvoiceSearch = (reset = true) => {
    if (reset) {
      setInvoiceSearch("");
      loadInvoiceData(true);
    }
  };

  const handleShowInvoicePicture = async (id) => {
    setLoading(true);
    const res = await ShowInvoiceApprovedFile(id);
    if (!res?.success) {
      if (res?.status !== 404)
        toast({
          title: "خطایی رخ داد",
          description: res?.error,
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      setLoading(false);
      return;
    }
    const url = URL.createObjectURL(res.data);
    setApprovedFile(url);
    setShowModal(true);

    setLoading(false);
  };

  useEffect(() => {
    loadInvoiceData();
  }, [currentInvoicePage]);

  dayjs.extend(jalali);

  const handleDialogClose = (result) => {
    setIsDialogOpen(false);
    if (result === "Confirm") dialogGears.callBack(invoiceSelectedID);
  };

  const handleDeleteInvoice = async (id) => {
    setInvoiceSelectedID(id);
    setLoading(true);
    const res = await RemoveInvoice(id);
    if (!res?.success) {
      toast({
        title: "خطایی رخ داد",
        description: res?.error,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      setLoading(false);
      return;
    }
    const newInvoices = invoices.filter((p) => p.id != id);
    setInvoices(newInvoices);
    toast({
      title: "توجه",
      description: `اطلاعات فاکتور شما حذف شد`,
      status: "success",
      duration: 3000,
      isClosable: true,
    });

    setLoading(false);
  };

  const updateInvoiceList = (id) => {
    const newInvoices = invoices.filter((i) => i.id != id);
    setInvoices(newInvoices);
  };

  const handleAcceptInvoice = async (id) => {
    setLoading(true);
    await SetInvoiceIsAccepted(id)
      .then((res) => {
        updateInvoiceList(id);
        toast({
          title: "توجه",
          description: `فاکتور شما تایید شد`,
          status: "success",
          duration: 3000,
          isClosable: true,
        });
      })
      .catch((err) => {
        toast({
          title: "خطایی رخ داد",
          description: `${err}`,
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      });
    setLoading(false);
  };

  return (
    <Box>
      <Flex direction="column" minH="77vh" filter={loading ? "blur(10px)" : ""}>
        <SearchBar
          zIndex="2"
          yTop="0px"
          search={invoiceSearch}
          setSearch={setInvoiceSearch}
          handleResetSearch={handleResetInvoiceSearch}
          loadData={loadInvoiceData}
          userInfo="جستجوی فاکتور"
        />
        <Box flex="1" overflowY="auto" p={1}>
          <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }}>
            {invoices?.map((row) => (
              <Card
                maxW="300px"
                _hover={{
                  cursor: "",
                  borderColor: "green.500",
                }}
                borderWidth="1px"
                borderColor="gray.300"
              >
                <CardHeader
                  py={2}
                  px={4}
                  borderTopRadius={5}
                  bg={
                    !row.isConverted
                      ? row?.isAccepted
                        ? "green.400"
                        : "blue.200"
                      : "gray.400"
                  }
                  _hover={{ cursor: "pointer" }}
                  onClick={(e) => {
                    setInvoiceSelectedID(row.id);
                    handleShowInvoicePicture(row.id);
                  }}
                >
                  <Text fontFamily="IranSans" fontSize="md">
                    فاکتور شماره :{row?.invoiceNumber}
                  </Text>
                </CardHeader>
                <CardBody p={2}>
                  <Flex justify="center" direction="row" columnGap={1}>
                    <MyInvoiceStepper data={row} />
                    <VStack
                      fontFamily="IranSans"
                      fontSize="10px"
                      p={1}
                      spacing={2}
                      align="stretch"
                    >
                      <HStack>
                        <Text>عنوان : </Text>
                        <Text fontFamily="IranSans" fontSize="12px">
                          {row.title}
                        </Text>
                      </HStack>
                      <Divider />
                      <HStack>
                        <Text>تاریخ : </Text>
                        <Text fontFamily="IranSans" fontSize="15px">
                          {dayjs(row?.createdAt)
                            .locale("fa")
                            .format("YYYY/MM/DD")}
                        </Text>
                      </HStack>
                      <Divider />
                      <HStack>
                        <Text>نام مشتری : </Text>
                        <Text fontFamily="IranSans" fontSize="12px">
                          {row.customer?.customerFName +
                            " " +
                            row.customer?.customerLName}
                        </Text>
                      </HStack>
                      <Divider />
                      <HStack>
                        <Text>نوع پرداخت : </Text>
                        <Text fontFamily="IranSans" fontSize="12px">
                          {row.paymentStatus}
                        </Text>
                      </HStack>
                      <Divider />
                      <HStack>
                        <Text> تایید مشتری : </Text>
                        <Text fontFamily="IranSans" fontSize="12px">
                          {row.approvedFile ? "دارد" : "ندارد"}
                        </Text>
                      </HStack>
                      <Divider />
                      <HStack>
                        <Text> جمع کل : </Text>
                        <Text fontFamily="IranSans" fontSize="15px">
                          {Number(row.totalAmount).toLocaleString()}
                        </Text>
                      </HStack>
                    </VStack>
                  </Flex>
                </CardBody>
                <CardFooter p={2} borderBottomRadius={5} bg="gray.100">
                  <Stack
                    direction={["row"]}
                    spacing={2}
                    align={"stretch"}
                    mr="auto"
                  >
                    <Link
                      _hover={{ color: "#ffd54f" }}
                      color="orange.300"
                      onClick={(e) => {
                        setInvoiceSelectedID(row.id);
                        setDialogGears({
                          title: "تایید  فاکتور",
                          text: "از تایید این فاکتور اطمینان دارید؟",
                          callBack: () => handleAcceptInvoice(row.id),
                        });
                        setIsDialogOpen(true);
                      }}
                    >
                      <Tooltip label="تایید">
                        <Icon w={6} h={6} as={ShieldCheck} />
                      </Tooltip>
                    </Link>

                    <Link
                      _hover={{ color: "#ffd54f" }}
                      color="green.600"
                      onClick={(e) => {
                        setInvoiceSelectedID(row.id);
                        handleShowInvoicePicture(row.id);
                      }}
                    >
                      <Tooltip label="مشاهده مدارک مشتری">
                        <Icon w={6} h={6} as={ScanEye} />
                      </Tooltip>
                    </Link>

                    <Link
                      _hover={{ color: "#ffd54f" }}
                      color="red.600"
                      onClick={(e) => {
                        setInvoiceSelectedID(row.id);
                        setDialogGears({
                          title: "حذف فاکتور",
                          text: "از حذف این فاکتور اطمینان دارید؟",
                          callBack: handleDeleteInvoice,
                        });
                        setIsDialogOpen(true);
                      }}
                    >
                      <Tooltip label="حذف">
                        <Icon w={6} h={6} as={Trash2} />
                      </Tooltip>
                    </Link>
                  </Stack>
                </CardFooter>
              </Card>
            ))}
          </SimpleGrid>
        </Box>
      </Flex>
      <Pagination
        currentPage={currentInvoicePage}
        totalPages={totalInvoicePages}
        onPageChange={(page) => setCurrentInvoicePage(page)}
      />
      <MyAlert
        onClose={handleDialogClose}
        isOpen={isDialogOpen}
        AlertHeader={dialogGears.title}
        AlertMessage={dialogGears.text}
      />
      <MyModal
        modalHeader=" فایل تاییدیه مشتری"
        onClose={() => setShowModal(false)}
        isOpen={showModal}
        size={isDesktop ? "xl" : "xs"}
      >
        <Box
          overflow="auto"
          borderRadius="6px"
          borderColor="orange"
          borderWidth="1px"
          hidden={approvedFile == null || approvedFile == ""}
          boxSize={isDesktop ? "lg" : "2xs"}
        >
          <Image
            src={approvedFile ? approvedFile : ""}
            objectFit="cover"
            target="_blank"
            rel="noopener noreferrer"
            alt="تاییدیه"
          />
        </Box>
      </MyModal>
      {loading && <MyLoading />}
    </Box>
  );
};
